



// Vue
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';

// Components
import Btn, {
  BtnColor,
  BtnWidth,
  BtnHeight,
  BtnFontSize,
  BtnPredefinedStyle,
} from '@/shared/components/btn.component.vue';
import ItemThumb, {
  ItemThumbPrefeginedStyle,
  TittleFontFamily,
  SubtitleFontFamily,
} from '@/shared/components/item-thumb.component.vue';

// Models / Interfaces
import { DelegationInterface } from '@/shared/interfaces/delegation.interface';

@Component({
  components: {
    Btn,
    ItemThumb,
  },
  computed: {
    ...mapGetters({
      currentBudget: 'getCurrentBudgetAcceptance',
      delegationList: 'getDelegationListAcceptance',
      getCurrentBudgetAcceptanceDelegation:
        'getCurrentBudgetAcceptanceDelegation',
      getDelegation: 'getDelegation',
    }),
  },
})
export default class ChooseDelegation extends Vue {
  @Prop({ default: true }) private showHeader!: boolean;

  private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
  private btnColor = BtnColor;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private btnWidth = BtnWidth;
  private btnHeight = BtnHeight;
  private btnFontSize = BtnFontSize;
  private tittleFontFamily = TittleFontFamily;
  private subtitleFontFamily = SubtitleFontFamily;
  private delegationList!: any;
  private getCurrentBudgetAcceptanceDelegation!: any;
  private currentBudget!: any;
  private getDelegation!: any;
  private showDelegations = false;
  private literals = {
    title: 'Provincias',
    subtitle:
      'Elige las provincias a las que estarías dispuesto a desplazarte para acudir a las convocatorias:',
  };

  private created() {
    this.initializeComponent();
  }

  private selectDelegation(delegation: DelegationInterface) {
    this.$store.dispatch(
      'updateCurrentBudgetAcceptanceDelegationList',
      delegation,
    );

  }

  private addDelegation(delegation: DelegationInterface) {
    this.$store.dispatch('setCurrentBudgetAcceptanceDelegationList', [
      delegation,
    ]);
  }

  private fetchDelegationList(
    callback: any = () => {
      const a = 1;
    },
  ) {
    return this.$store.dispatch('fetchDelegationList');
  }

  private delegationActive(delegation: DelegationInterface) {
    return (
      this.getCurrentBudgetAcceptanceDelegation(delegation.id) !== undefined
    );
  }

  private showDelegationsTimeout(time: number = Constants.middleTimeoutTime) {
    // this.delegationList.forEach(delegation => {
    //   console.log(delegation.id)
    //   setTimeout(() => {
    //   // this.selectDelegation(delegationsId);
    //     this.selectDelegation(delegation.id);
    // }, 5000);
    // });
    let delegationsId = this.delegationList.map((delegation: any) => delegation.id);
    // setTimeout(() => {
    //   // this.selectDelegation(delegationsId);
    //     // this.selectDelegation(delegation.id);
    // }, 5000);
    setTimeout(() => {
      // this.selectDelegation(delegationsId);
      this.showDelegations = true;
    }, time);
  }

  private async initializeComponent() {
    if (this.delegationList.length === 0) {
      this.showDelegations = false;
      const res = await this.fetchDelegationList();

      const budgetDelegation = this.currentBudget.delegation;

      // this.delegationList.forEach(delegation => {
      //   this.addDelegation(this.getDelegation(delegation.id));
      // });
      // console.log(budgetDelegation)
      // this.$store.dispatch('setCurrentBudgetAcceptanceDelegationList', [
      //   res['results'],
      // ]);
      if (budgetDelegation) {
        this.addDelegation(this.getDelegation(budgetDelegation));
      } else {
        this.addDelegation(this.getDelegation(res['results'][0]['id']));
      }

      this.showDelegationsTimeout(Constants.defaultTimeoutTime);
    } else {
      this.showDelegationsTimeout();
    }
  }
}
